import React from 'react';
import {Link} from 'react-router-dom'

const Portfolio = ({id, data, thumb, classes, title, category, variant}) => {
    
    const getDirectLink = (url) => {
        if (!url) return "https://via.placeholder.com/600x400?text=No+Image";

        const match = url.match(/(?:\/d\/|id=)([\w-]+)/);
        const fileId = match ? match[1] : null;

        if (fileId) {
            return `https://drive.google.com/thumbnail?id=${fileId}&sz=w372`;
        }
        return url;
    };
        
    return (
        <div className={`portfolio-item ${classes ? classes : ' '}`}>
            {/* <Link to={`${process.env.PUBLIC_URL + "/portfolio-details"}`} className={'d-block'}> */}
            <Link to={{pathname: `${process.env.PUBLIC_URL}/portfolio-details/${id}`, state: { portfolioData: data }}} className={'d-block'}>
                <div className="portfolio-image">
                    {variant === 'column' ? (
                        <img src={getDirectLink(thumb)} alt={title} style={{ width: '100%', height: 'auto' }} />
                    ) : (
                        <div 
                            className="portfolio-image-bg"
                            style={{
                                backgroundImage: `url(${getDirectLink(thumb)})`,
                                height: '250px',
                                backgroundSize: 'cover',
                                backgroundPosition: 'center'
                            }}
                        />
                    )}
                </div>
                <div className="portfolio-content">
                    <h4 className="title">{title}</h4>
                    <div className="category"><span>{category}</span></div>
                </div>
            </Link>
        </div>
    );
};

export default Portfolio;
